module.exports = __webpack_public_path__ + "241de96d5101a493af078773d9002b43.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/roguecompany/icarus.png
// module id = 439
// module chunks = 0